import { makeStyles } from "@material-ui/core"

export const NumberRangeStyle = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
        height: '100%',
        width: '100%'
    },
    numberRange: {
        backgroundColor: theme.palette.background.default,
        '& fieldset': {
            border: 'none'
        },

    },
    rangeSelected: {
        backgroundColor: theme.palette.background.default,

    },
    rangeOpt: {
        padding: '1em',
        width: '100%',
        height: '100%'
    },
    rangePicker: {
        '& .rdrInputRanges': {
            display: 'none !important'
        },
        '& .rdrStaticRangeLabel': {
            padding: '0'
        },
        display: 'flex'
    },
    input: {
        border: 0,
        color: theme.palette.common.darkText,
    },
    label: {
        color: theme.palette.text.secondary,

    },
    boxCalendar: {
        position: 'fixed',
        background: '#fff',
        border: "solid 1px #aab5bd",
        borderRadius: '5px',
        zIndex: 2,
        marginTop: '3.5rem',
    },
    closeAndClear: {
        textAlign: 'center',
        padding: '0.5rem',
    },
    close: {
        cursor: 'pointer',
        border: "1px solid #aab5bd",
        borderRadius: '5px',
        background: '#f7f6fb',
        textAlign: 'center',
        padding: '0.3rem',
        margin: '0.5rem',
        '&:hover': {
            opacity: 0.6
        }
    },
    inlineWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: 6,
        padding: '4px 0',
    },
    inlineField: {
        flex: 1,
        cursor: 'pointer',
    },
    inlineInput: {
        fontSize: 12,
        padding: '4px 6px',
        cursor: 'pointer',
    },
    inlineLabel: {
        fontSize: 12,
    },
    inlineApplyButton: {
        fontSize: 11,
        minWidth: 0,
        padding: '2px 6px',
        textTransform: 'none',
    },

}));